import React, { useEffect, useState } from "react";
import CategoryForpickup from "./CategoryForPickup";
import { withFirebase } from "../../firebase";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Container = ({ firebase }) => {
	const { t } = useTranslation();
	const [data, setData] = useState([]);
	const [isActiveCategoriesSnackbar, setIsActiveCategoriesSnackbar] =
		useState(false);

	const getData = () => {
		const currentCity = JSON.parse(localStorage.getItem("chosenCity"));
		const currentBrand = JSON.parse(localStorage.getItem("chosenBrand"));
		const isDebug = JSON.parse(localStorage.getItem("isDebug"));

		const adminPermission = JSON.parse(localStorage.getItem("adminPermission"));
		const isNewAdmin = adminPermission?.newAdmin;

		const ref = isNewAdmin
			? `web/settings/city/${currentCity}/brands/${currentBrand}/category/categoryIdsOnlyForPickUp`
			: `web/settings/city/${currentCity}/category/categoryIdsOnlyForPickUp`;

		const refPath = `${isDebug ? "debug/" : ""}${ref}`;

		// Получаем обновленные данные
		firebase.bd
			.ref(`${refPath}`)
			.once("value")
			.then((snapshot) => {
				const data = snapshot.val();

				setData(data || []); // Если данных нет, устанавливаем пустой массив
			})
			.catch((error) => {
				console.error(t("categoryForPickup.fetchError"), error);
			});
	};

	const saveData = (newData) => {
		const currentCity = JSON.parse(localStorage.getItem("chosenCity"));
		const currentBrand = JSON.parse(localStorage.getItem("chosenBrand"));
		const isDebug = JSON.parse(localStorage.getItem("isDebug"));
		const adminPermission = JSON.parse(localStorage.getItem("adminPermission"));
		const isNewAdmin = adminPermission?.newAdmin;

		const ref = isNewAdmin
			? `web/settings/city/${currentCity}/brands/${currentBrand}/category/categoryIdsOnlyForPickUp`
			: `web/settings/city/${currentCity}/category/categoryIdsOnlyForPickUp`;

		const refPath = `${isDebug ? "debug" : ""}${ref}`;

		// Если newData пустой или не передан, создаем объект с пустой строкой
		const dataToSave =
			newData && newData.length > 0 ? newData : { emptyElement: "" };

		firebase.bd
			.ref(refPath)
			.set(dataToSave)
			.then(() => {
				console.log(t("categoryForPickup.saveSuccess"));
				setIsActiveCategoriesSnackbar(true);
				getData();
			})
			.catch((error) => {
				console.error(t("categoryForPickup.saveError"), error);
			});
	};

	useEffect(() => {
		getData();
	}, []);

	return (
		<div>
			<CategoryForpickup
				saveData={saveData}
				data={data}
				setIsActiveCategoriesSnackbar={setIsActiveCategoriesSnackbar}
				isActiveCategoriesSnackbar={isActiveCategoriesSnackbar}
			/>
		</div>
	);
};

export default withFirebase(withRouter(Container));
